// useBodyScrollLock.js
import { useEffect } from 'react';

const UseBodyScrollLock = (isLocked) => {
    useEffect(() => {
        if (isLocked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Clean up the effect when the component unmounts
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLocked]);
};

export default UseBodyScrollLock;